import { ITabs } from '../components/SideBar/Tabs/AdminTabs'

const useCurrentTabWithParams = (tabs: ITabs[]) => {
  const activeIndex = tabs.findIndex((tab) => {
    return location.pathname.startsWith(tab.fullPath ?? '')
  })

  return activeIndex ?? 0
}

export default useCurrentTabWithParams
